import { useEffect, useRef } from 'react';

import { useIncidentDistinctFieldValuesData } from './useIncidentDistinctFieldValuesData';

const PRE_SELECTED_VERIFICATION_SOURCE = 'Human-Verified';
const VERIFICATION_SOURCE_FILTER_KEY = 'VerificationSource';

interface UsePreselectFiltersDataParams {
  setPreselectFilters: (filters: { verificationSources: string[] }) => void;
}

export const usePreselectFiltersData = ({
  setPreselectFilters,
}: UsePreselectFiltersDataParams) => {
  const isPreSelectApplied = useRef(false);

  const {
    items: verificationSourceItems,
    isFetching: isFetchingVerificationSourceData,
  } = useIncidentDistinctFieldValuesData(VERIFICATION_SOURCE_FILTER_KEY);

  useEffect(() => {
    if (isFetchingVerificationSourceData || isPreSelectApplied.current) {
      return;
    }

    if (!verificationSourceItems.includes(PRE_SELECTED_VERIFICATION_SOURCE)) {
      isPreSelectApplied.current = true;
      return;
    }

    isPreSelectApplied.current = true;
    setPreselectFilters({ verificationSources: [PRE_SELECTED_VERIFICATION_SOURCE] });
  }, [verificationSourceItems, isFetchingVerificationSourceData, setPreselectFilters]);

  return {
    verificationSourceItems,
    isFetchingVerificationSourceData,
    isPreSelectApplied: isPreSelectApplied.current,
  };
};
